<template>
  <div class="meun">
    <ul class="fs16">
      <li>
        <router-link :class="hover_romasterlab" :to="'/function/romasterlab'" title="刷机大师(PC)">刷机大师(PC)</router-link>
      </li>
      <li>
        <router-link :class="hover_andromaster" :to="'/function/andromaster'" title="刷机大师(手机)">刷机大师(手机)</router-link>
      </li>
      <li>
        <router-link
          :class="hover_vroot"
          :to="'/function/vroot'"
          title="ROOT大师(PC)"
        >ROOT大师(PC)</router-link>
      </li>
      <li>
        <router-link
          :class="hover_irootm"
          :to="'/function/irootm'"
          title="ROOT大师(手机)"
        >ROOT大师(手机)</router-link>
      </li>
      <li>
        <router-link :class="hover_supercleaner" :to="'/function/supercleaner'" title="安卓清理大师">安卓清理大师</router-link>
      </li>
      <li>
        <router-link :class="hover_onelocker" :to="'/function/onelocker'" title="WP桌面">锁大师</router-link>
      </li>
      <li>
        <router-link :class="hover_appcool" :to="'/function/appcool'" title="应用酷">应用酷</router-link>
      </li>
      <li>
        <router-link :class="hover_wp8launcher" :to="'/function/wp8launcher'" title="WP桌面">WP桌面</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ProductMenu",
  props: {
    now: {
        type: String,
        default: 'romasterlab'
    }
  },
  computed: {
    hover_romasterlab() {
      return this.hover('romasterlab')
    },
    hover_andromaster() {
      return this.hover('andromaster')
    },
    hover_vroot() {
      return this.hover('vroot')
    },
    hover_irootm() {
      return this.hover('irootm')
    },
    hover_supercleaner() {
      return this.hover('supercleaner')
    },
    hover_romjd() {
      return this.hover('romjd')
    },
    hover_appcool() {
      return this.hover('appcool')
    },
    hover_onelocker() {
      return this.hover('onelocker')
    },
    hover_wp8launcher() {
      return this.hover('wp8launcher')
    }
  },
  methods: {
    hover(v) { return v === this.now ? "hover" : "" }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/function/ProductMenu.vue